import React, { forwardRef, useEffect, useState } from "react";
// import { useSelector } from "react-redux";
import "./erf_Printout.scss";
import moment from "moment"; // You may need to install moment or use native Date

const EarlyClosureFormPrintout = forwardRef((props, ref) => {
  //   const appConfig = useSelector((state) => state?.app?.appConfig);
  // eslint-disable-next-line
  const [data, setData] = useState({});

  useEffect(() => {
    if (props?.data) {
      setData(props.data);
    }
  }, [props]);

  // Helper function to format date
  const formatDate = (dateString) => {
    if (!dateString) return "";
    return moment(dateString).format("DD-MMM-YYYY");
  };

  // Helper function to format date for table
  const formatTableDate = (dateString) => {
    if (!dateString) return "";
    return moment(dateString).format("DD/MM/YYYY");
  };

  return (
    <>
      <div ref={ref} className="formContainer mb-5 pb-5">
        <div className="max-w-5xl mx-auto bg-white p-8 shadow-lg text-sm">
          {/* <!-- Header --> */}
          <div className="flex justify-between items-start mb-6">
            <div>
              {/* <h1 className="text-red-600 text-2xl font-bold">MediRent</h1> */}
              <div>
                <img
                  src="/assets/img/medirent/printoutimage/mediretnlogo.jpg"
                  alt="Medical Equipment Header"
                  className="img"
                />
              </div>
            </div>
            <h2 className="text-xl font-bold">EARLY CLOSURE FORM</h2>
          </div>

          {/* <!-- Top Details --> */}
          <div className="grid grid-cols-2 gap-8 mb-6">
            {/* <!-- Left Column --> */}
            <div className="space-y-1">
              <p>
                <strong>Date :</strong> {formatDate(data?.orderDate) || "07-Feb-2026"}
              </p>
              <p>
                <strong>Agreement Date :</strong> {formatDate(data?.erfStartDate) || "29-Jan-2026"}
              </p>
              <p>
                <strong>Agreement Closure Date :</strong> {formatDate(data?.erfEndDate) || "28-Feb-2026"}
              </p>
              <p>
                <strong>Early Closure Date :</strong> {formatDate(data?.earlyClosureDate) || "31-Jan-2026"}
              </p>
              <p>
                <strong>Cost Center :</strong> {data?.costCenter || "CCN AT HOME"}
              </p>
              <br />
              <p>
                <strong>Customer's Name :</strong> {data?.patientName || "IQBAL SINGH"}
              </p>
              <p>
                <strong>Email Id :</strong> {data?.email || data?.emailId || "INFO@MEDIRENT.IN"}
              </p>
              <p>
                <strong>Patient's Name :</strong> {data?.patientName || "IQBAL SINGH"}
              </p>
              <p>
                <strong>Challenges :</strong> {data?.patientChallenges || "____________________"}
              </p>
              <p>
                <strong>Billing Address :</strong> {data?.billingAddress || "APP 1204 TOWER E BESTECH ALTURA SEC 79 GGN"}
              </p>
              <p>
                <strong>Delivery Address :</strong> {data?.deliveryAddress || "APP 1204 TOWER E BESTECH ALTURA SEC 79 GGN"}
              </p>
              <p>
                <strong>Pending Amount (if any) :</strong> {data?.balanceAmount ? `₹${data.balanceAmount}` : "__________"}
              </p>
            </div>

            {/* <!-- Right Column --> */}
            <div className="space-y-1">
              <p>
                <strong>ERF S.No. :</strong> {data?.documentNumber || data?.equipmentRentNr || "CCNO-168/2526"}
              </p>
              <p>
                <strong>Bill No :</strong> {data?.billNo || "PMSOG-01107"}
              </p>
              <p>
                <strong>PCE Code :</strong> {data?.rentItems?.[0]?.storageLocn || "MASTER STORE"}
              </p>
              <p>
                <strong>Relationship :</strong> {data?.caregiverRelation || "__________"}
              </p>
              <p>
                <strong>Customer's Phn No. :</strong> {data?.mobileNr || "XXXXXXXX04"}
              </p>
              <p>
                <strong>Patient's No. :</strong> {data?.mobileNr || "XXXXXXXX04"}
              </p>
              <p>
                <strong>Cash Receipt No :</strong> {data?.receiptNo || "CCNRCO-168/2526"}
              </p>
            </div>
          </div>

          {/* <!-- Rental Products Section --> */}
          <h3 className="font-bold border-b pb-1 mb-2">
            RENTAL PRODUCTS RECEIVED BACK
          </h3>

          <table className="w-full border border-gray-400 text-xs mb-6">
            <thead>
              <tr className="bg-gray-100">
                <th className="border p-2">Sr. No.</th>
                <th className="border p-2">Early Closure Date</th>
                <th className="border p-2">Product Code</th>
                <th className="border p-2">Products</th>
                <th className="border p-2">Qty</th>
              </tr>
            </thead>
            <tbody>
              {data?.rentItems && data.rentItems.length > 0 ? (
                data.rentItems.map((item, index) => (
                  <tr key={index}>
                    <td className="border p-2">{index + 1}</td>
                    <td className="border p-2">
                      {formatTableDate(data?.earlyClosureDate) || "31/01/2026"} - Stock IN
                    </td>
                    <td className="border p-2">{item.materialCode || "SUM016"}</td>
                    <td className="border p-2">
                      {item.materialDescription || "SUCTION MACHINE (SM ANAND)"}
                      <br />
                      <span className="font-semibold">Barcode: {item.barcode || "06SUM016000007"}</span>
                    </td>
                    <td className="border p-2">{item.orderedQuantity || 1} UNIT</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="border p-2">1</td>
                  <td className="border p-2">31/01/2026 - Stock IN</td>
                  <td className="border p-2">SUM016</td>
                  <td className="border p-2">
                    SUCTION MACHINE (SM ANAND)
                    <br />
                    <span className="font-semibold">Barcode: 06SUM016000007</span>
                  </td>
                  <td className="border p-2">1 UNIT</td>
                </tr>
              )}
            </tbody>
          </table>

          {/* <!-- Damaged / Missing --> */}
          <div className="grid grid-cols-2 gap-8 mb-6">
            <div>
              <h3 className="font-bold mb-2">DAMAGED/MISSING PRODUCTS</h3>
              <div className="border-b h-6 mb-3"></div>
              <div className="border-b h-6 mb-3"></div>
              <div className="border-b h-6 mb-3"></div>
              <div className="border-b h-6"></div>
            </div>

            <div className="space-y-3 text-xs">
              <p>
                Products received are in good condition?
                <span className="ml-4">☐ Yes ☐ No</span>
              </p>

              <p>
                All relevant Accessories of products received back?
                <span className="ml-4">☐ Yes ☐ No</span>
              </p>

              <p>
                Total Payment Received?
                <span className="ml-4">☐ Yes ☐ No</span>
              </p>

              <p>
                Security Cheques/Amount Given back to customer?
                <span className="ml-4">☐ Yes ☐ No</span>
              </p>

              <div>
                <p className="mb-1">Cheque Details</p>
                <div className="border h-24"></div>
              </div>
            </div>
          </div>

          {/* <!-- Cash Receipt --> */}
          <div className="mb-6">
            <h3 className="font-bold mb-2">CASH RECEIPT</h3>
            <p className="text-xs mb-4">
              I do hereby declare that the security cheque/amount has been
              received from MEDIRENT and the contract may now be considered
              closed.
            </p>

            <div className="grid grid-cols-2 gap-8 mb-6">
              <div>
                <p>Service Executive Name: ________________________</p>
                <p>Store Executive Name: ________________________</p>
              </div>
            </div>
          </div>

          {/* <!-- Signature --> */}
          <div className="flex justify-between mt-10">
            <div className="text-center">
              <div className="border-t w-48 mx-auto mb-1"></div>
              <p className="text-xs">Authorized By</p>
            </div>

            <div className="text-center">
              <div className="border-t w-48 mx-auto mb-1"></div>
              <p className="text-xs">(Customer's Signature)</p>
            </div>
          </div>

          {/* <!-- Footer --> */}
          <div className="mt-10 text-xs text-gray-600">
            <p>
              <strong>Terms & Conditions</strong>
            </p>
            <p>
              1) In case of Refund, Refund will be processed within 2-3 working
              days.
            </p>
            <p>2) Refunds will be processed "Online" only.</p>
          </div>
        </div>
      </div>
    </>
  );
});

export default EarlyClosureFormPrintout;